import { Box, Button, Image, Stack, Text } from "@chakra-ui/react";
import { signIn } from "next-auth/react";

const Unauthorized = () => {
    return (
        <Box textAlign="center" py={6} px={3} minW="100vw" minH="100vh" alignContent="center">
            <Stack alignItems="center">
                <Image
                    mb="20px"
                    height="80px"
                    w="min"
                    src="https://media.grupoguia.mx/assets/apps-icons/warning_icon.png"
                    alt="simple icon"
                />
            </Stack>
            <Stack>
                <Text fontSize="4xl">401</Text>
                <Text fontSize="2xl">Unauthorized</Text>
            </Stack>
            <Stack alignItems="center">
                <Button mt="20px" w="fit-content" colorPalette="blue" onClick={() => signIn()}>
                    Inicia Sesión para acceder a esta sección
                </Button>
            </Stack>
        </Box>
    );
};

export default Unauthorized;
